import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Example async thunk for submitting a blog post
export const submitPropertyPost = createAsyncThunk(
    'blog/submitPropertyPost',
    async (propertyData, thunkAPI) => {
        // Replace with your API call
        console.log('...propertyData...for...submission on server...', propertyData)
        const response = await fetch(`${process.env.REACT_APP_BASE_URL ?? "https://backend.carbez.com"}/api/property`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(propertyData),
        });
        if (!response.ok) {
            throw new Error('Failed to submit property post');
        }
        return await response.json();
    }
);

export const submitUpdatePost = createAsyncThunk(
  'blog/submitUpdatePost',
  async ({ updatedData }, thunkAPI) => {
    try {
      const baseURL = process.env.REACT_APP_BASE_URL || "https://backend.carbez.com";
      const token = localStorage.getItem('token');


      const response = await fetch(`${baseURL}/api/constants`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update property post');
      }

      const result = await response.json();
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Update failed");
    }
  }
);


export const deletePropertyPost = createAsyncThunk(
    'blog/deletePropertyPost',
    async (id, thunkAPI) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL ?? "https://backend.carbez.com"}/api/property/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
        });
        if (!response.ok) {
            throw new Error('Failed to delete property post');
        }
        const { data } = await response.json();
        return data;
    }
);

export const fetchDepositeAmount = createAsyncThunk(
    'blog/fetchDepositeAmount',
    async (_, thunkAPI) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL ?? "https://backend.carbez.com"}/api/constants`);
        if (!response.ok) {
            throw new Error('Failed to fetch deposite amount');
        }
        const fetchedData = await response.json();
        return fetchedData;
    }
);

const initialState = {
    title: '',
    content: '',
    items: [],          // ⬅️ stores fetched blogs
    status: 'idle',
    error: null,
};


const depositeAmountSlice = createSlice({
    name: 'depositeAmount',
    initialState,
    reducers: {
        setTitle(state, action) {
            state.title = action.payload;
        },
        setContent(state, action) {
            state.content = action.payload;
        },
        resetProperty(state) {
            state.title = '';
            state.content = '';
            state.status = 'idle';
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitPropertyPost.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(submitPropertyPost.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(submitPropertyPost.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(fetchDepositeAmount.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDepositeAmount.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload; // ⬅️ populate Propertys
            })
            .addCase(fetchDepositeAmount.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    },
});

export const { setTitle, setContent, resetProperty } = depositeAmountSlice.actions;

export default depositeAmountSlice.reducer;